import { Region } from 'clickNgo/configs/geo'
import { IUser } from 'core-components/sitebuilder/models/IUser'
import { MarketApi } from 'core/classes/services/api/MarketApi'

export const getUserRegion = (user: IUser) => {
  return MarketApi.getRegion(user.geoMarket).Region as Region
}
